import './index.css';
import { bool, func, object, string } from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
function GeniusButton(props) {
    GeniusButton.propTypes = {
        className: string,
        icon: string,
        id: string,
        isDisabled: bool,
        onClick: func,
        style: object,
        svg: string,
        text: string,
        textBlock: object,
    };
    const classes = (props.className)
        ? props.className + ' remove-focus-highlight'
        : 'remove-focus-highlight';
    let key = props.id ? props.id : '';
    key += props.icon;
    const style = props.style || {};
    return (React.createElement(Button, { className: classes, variant: '', disabled: (props.isDisabled) ? props.isDisabled : false, id: props.id ? props.id : '', key: key, onClick: props.onClick, style: style },
        (props.icon)
            ? React.createElement(React.Fragment, null,
                React.createElement("span", { className: 'fa-lg ' + props.icon }),
                "\u00A0\u00A0")
            : (props.svg)
                ? React.createElement("img", { src: props.svg, alt: '' })
                : null,
        (props.text)
            ? props.text
            : (props.textBlock)
                ? props.textBlock
                : ''));
}
export default GeniusButton;
